import { sanitizeJobHtml } from '../../utils/jobHtml';

function getBlockClass(block) {
  return [
    'job-content-block',
    `job-content-block--${block.type || 'paragraph'}`,
    `job-content-block--size-${block.fontSize || 'normal'}`,
    `job-content-block--weight-${block.fontWeight || 'normal'}`,
    block.bold ? 'is-bold' : '',
    block.italic ? 'is-italic' : '',
  ]
    .filter(Boolean)
    .join(' ');
}

function JobContentBlocks({ blocks = [], html = '' }) {
  const safeHtml = html ? sanitizeJobHtml(html) : '';

  if (safeHtml) {
    return (
      <div className="job-description-section">
        <p className="job-description-section__eyebrow">JOB DESCRIPTION</p>
        <div className="job-description-box">
          <div className="job-content job-content--rich" dangerouslySetInnerHTML={{ __html: safeHtml }} />
        </div>
      </div>
    );
  }

  if (!blocks.length) {
    return (
      <div className="job-description-section">
        <p className="job-description-section__eyebrow">JOB DESCRIPTION</p>
        <div className="job-description-box">
          <p>No detailed description has been added yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="job-description-section">
      <p className="job-description-section__eyebrow">JOB DESCRIPTION</p>
      <div className="job-description-box">
        <div className="job-content">
          {blocks.map((block, index) => {
            const key = `${block.type || 'block'}-${index}`;
            const className = getBlockClass(block);

            if (block.type === 'heading') {
              return (
                <h3 className={className} key={key}>
                  {block.text}
                </h3>
              );
            }

            if (block.type === 'list' || block.type === 'numberedList') {
              const ListTag = block.type === 'numberedList' ? 'ol' : 'ul';
              return (
                <ListTag className={className} key={key}>
                  {(block.items || []).map((item, itemIndex) => (
                    <li key={`${key}-${itemIndex}`}>{item}</li>
                  ))}
                </ListTag>
              );
            }

            if (block.type === 'link') {
              return (
                <p className={className} key={key}>
                  <a href={block.href || '#'} rel="noreferrer" target="_blank">
                    {block.text || block.href}
                  </a>
                </p>
              );
            }

            if (block.type === 'divider') {
              return <hr className="job-content-divider" key={key} />;
            }

            return (
              <p className={className} key={key}>
                {block.text}
              </p>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default JobContentBlocks;
